import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import Reveal from "@/components/Reveal";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const googleLogin = () => {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back.");
      navigate("/dashboard");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-mahogany-950 to-mahogany-800 px-6 pt-28 pb-16 grain" data-testid="login-page">
      <Reveal className="w-full max-w-md">
        <div className="text-center mb-8"><Logo size="md" /></div>
        <div className="bg-mahogany-950 gold-frame rounded-sm p-8">
          <p className="font-script text-3xl text-fuchsia text-center mb-1">Welcome back.</p>
          <h1 className="font-serif text-3xl text-cream text-center mb-8">Enter Your Room</h1>
          <button onClick={googleLogin} className="btn-secondary w-full mb-6" data-testid="google-login">Continue with Google</button>
          <div className="flex items-center gap-4 mb-6 text-cream/40 text-xs uppercase tracking-widest"><span className="flex-1 h-px bg-gold/20" /> or <span className="flex-1 h-px bg-gold/20" /></div>
          <form onSubmit={submit} className="space-y-6" data-testid="login-form">
            <input required type="email" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} className="input-line" data-testid="login-email" />
            <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-line" data-testid="login-password" />
            <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit">{busy ? "Signing in..." : "Sign In"}</button>
          </form>
          <p className="text-center text-cream/50 text-sm mt-6">New here? <Link to="/join" className="text-fuchsia">Join the room — it's free</Link></p>
        </div>
      </Reveal>
    </div>
  );
}
